var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fadeIn"}},[_c('div',{staticClass:"home"},[_c('h1',[_vm._v("N X X T Y")]),_c('h2',[_vm._v("Vous pouvez retrouver tous mes travaux sur ce site.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }